module.exports = __webpack_public_path__ + "assets/img/index-logo@2x.bb69ad3e.png";